<template>
  <div style="`width: ${width}px`">
    <div
      v-if="isMobile"
      class="spacer"
      v-waypoint="{
        active: true,
        callback: onSpacerIntersect,
        options: intersectionOptions
      }"
    />
    <FeaturedActivityPreview
      v-for="(activity, index) in activities"
      :key="activity.uri"
      :ref="`feature-${index}`"
      :activity="activity"
      :isMobile="isMobile"
      :blockPosition="index % 2"
      :highlight="index === currentIndex"
      :data-index="index"
      v-waypoint="{
        active: true,
        callback: onFeatureIntersect,
        options: intersectionOptions
      }"
    />
  </div>
</template>

<script>
import FeaturedActivityPreview from '../components/FeaturedActivityPreview'

export default {
  name: 'FeaturedActivities',

  components: {
    FeaturedActivityPreview
  },

  props: ['isMobile', 'activities', 'width'],

  data () {
    return {
      intersectionOptions: {
        root: null,
        rootMargin: '-49% 0% -49% 0%',
        thresholds: [0.0, 1.0]
      },
      currentIndex: null
    }
  },

  methods: {
    onSpacerIntersect (event) {
      if (event.going === this.$waypointMap.GOING_IN) {
        this.$emit('changeMobileScrollText', null)
        this.currentIndex = null
      }
    },

    onFeatureIntersect (event) {
      const index = parseInt(event.el.getAttribute('data-index'))
      if (event.going === this.$waypointMap.GOING_IN) {
        const title = event.el.getAttribute('data-title')
        const uri = event.el.getAttribute('data-uri')
        this.$emit('changeMobileScrollText', { title, uri })
        this.currentIndex = index
      } else {
        if (this.currentIndex === index) {
          this.currentIndex = null
        }
      }
    },

    mapValue (x, in_min, in_max, out_min, out_max)
    {
      return (x - in_min) * (out_max - out_min) / (in_max - in_min) + out_min
    }
  }
}
</script>

<style scoped lang="stylus">
.spacer {
  width: 100%;
  height: 75vh;
}
</style>
